import { render, staticRenderFns } from "./ClaimsBucket.UnreadMsg.vue?vue&type=template&id=6543d67a&"
import script from "./ClaimsBucket.UnreadMsg.vue?vue&type=script&lang=js&"
export * from "./ClaimsBucket.UnreadMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports